var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serviceStatistic-container"},[_c('a-row',{attrs:{"gutter":12}},[_c('a-col',{staticStyle:{"margin-bottom":"12px"},attrs:{"span":16}},[_c('div',{staticClass:"statistic-module",on:{"click":function($event){return _vm.$router.push({
          name: 'ServiceDashboardList',
          params: { statusType: 'all' }
        })}}},[_c('a-statistic',{attrs:{"title":"全部","value":_vm.dataSource.all,"valueStyle":{
            fontSize: '38px',
            lineHeight: '44px',
            textAlign: 'center',
            color: 'rgba(0,0,0,.5)',
            cursor: 'pointer'
          }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"12px"},attrs:{"span":8}},[_c('div',{staticClass:"statistic-module statistic-module_built",on:{"click":function($event){return _vm.$router.push({
          name: 'ServiceDashboardList',
          params: { statusType: 'built' }
        })}}},[_c('a-statistic',{attrs:{"title":"已建","value":_vm.dataSource.built,"valueStyle":{
            fontSize: '38px',
            lineHeight: '44px',
            textAlign: 'center',
            color: '#48b548',
            cursor: 'pointer'
          }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"12px"},attrs:{"span":8}},[_c('div',{staticClass:"statistic-module statistic-module_building",on:{"click":function($event){return _vm.$router.push({
          name: 'ServiceDashboardList',
          params: { statusType: 'building' }
        })}}},[_c('a-statistic',{attrs:{"title":"在建","value":_vm.dataSource.building,"valueStyle":{
            fontSize: '38px',
            lineHeight: '44px',
            textAlign: 'center',
            color: '#4d94f8',
            cursor: 'pointer'
          }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"12px"},attrs:{"span":8}},[_c('div',{staticClass:"statistic-module statistic-module_planned",on:{"click":function($event){return _vm.$router.push({
          name: 'ServiceDashboardList',
          params: { statusType: 'planned' }
        })}}},[_c('a-statistic',{attrs:{"title":"拟建","value":_vm.dataSource.planned,"valueStyle":{
            fontSize: '38px',
            lineHeight: '44px',
            textAlign: 'center',
            color: '#f19d48',
            cursor: 'pointer'
          }}})],1)]),_c('a-col',{staticStyle:{"margin-bottom":"12px"},attrs:{"span":8}},[_c('div',{staticClass:"statistic-module",on:{"click":function($event){return _vm.$router.push({
          name: 'ServiceDashboardList',
          params: { statusType: 'unknown' }
        })}}},[_c('a-statistic',{attrs:{"title":"未知","value":_vm.dataSource.unknown,"valueStyle":{
            fontSize: '38px',
            lineHeight: '44px',
            textAlign: 'center',
            color: 'rgba(0,0,0,.5)',
            cursor: 'pointer'
          }}})],1)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }